import React from 'react'
import PropTypes from 'prop-types'

export default function ValidatedCheckbox({ label, id, hasError, onChange, errorText, description }) {
    return (
        <div className="form-check form-switch">
            <label htmlFor={id}>{label}</label>
            {hasError ? (
                <>
                <input 
                className="form-check-input"
                type="checkbox"                
                id={id}
                onChange={onChange} />
                <div className="alert alert-danger" role="alert" style={{ padding: "0.2rem 0.2rem" }}>
                    {errorText}
                </div>
                </>
            ) : (
                <input className="form-check-input" type="checkbox" id={id} onChange={onChange} />
            )}

            {description &&
                <small id={id + "help"} className="form-text text-muted">{description}</small>
            }

        </div>
    )
}

ValidatedCheckbox.propTypes = {

    hasError: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    errorText: PropTypes.string.isRequired,
    description: PropTypes.string,
    onChange: PropTypes.func.isRequired
}
